<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Exercise Slot - {{ slot.slotName }}</cs-header-title>
</cs-header>

<cs-content>
  @if (slot) {
    <div class="form-content">
      <!-- Basic Fields -->
      <div class="form-row">
        <cs-form-field [label]="'Id' | untranslated" class="id-field">
          <cs-input [disabled]="true" type="text" [(value)]="slot._id"></cs-input>
          <span class="field-hint">Unique identifier. Generated from name on first edit. Cannot be changed later.</span>
        </cs-form-field>
        <cs-form-field [label]="'Name' | untranslated" class="name-field">
          <cs-input [placeholder]="'Enter slot name' | untranslated" type="text" [(value)]="slot.slotName"
          (valueChange)="nameChanged()"></cs-input>
          <span class="field-hint">Internal name for admins to choose slots in workout templates.</span>
        </cs-form-field>
      </div>
      <!-- Workout Exercises Section -->
      <div class="section">
        <cs-item-list-header>Workout exercises</cs-item-list-header>
        <cs-note>These exercises will actually be used in the fitness program.</cs-note>
        <div class="exercise-list">
          @for (exerciseEntry of slot.exercises; track exerciseEntry) {
            <div class="exercise-row">
              <!-- [ariaLabel] names the picker: the remove button shares this row, so there is
                   no row text the select can take its name from -->
              <cs-select class="exercise-select" [ariaLabel]="'Exercise' | untranslated"
                [placeholder]="'Select exercise...' | untranslated" [(value)]="exerciseEntry.exerciseId"
                [searchable]="true">
                @for (e of globalExercises; track e) {
                  <cs-select-option [value]="e._id" [label]="e.name | untranslated"></cs-select-option>
                }
              </cs-select>
              <cs-icon-button icon="close" (click)="removeExercise(exerciseEntry)"></cs-icon-button>
            </div>
          }
        </div>
        <cs-button tertiary icon="add" (click)="addExercise()">Add Exercise</cs-button>
      </div>
      <!-- Testing Exercises Section -->
      <div class="section">
        <cs-item-list-header>Testing exercises</cs-item-list-header>
        <cs-note>These exercises will be used for strength testing in the Intake page.</cs-note>
        <div class="toggle-row">
          <cs-label>Allow no added weight</cs-label>
          <cs-toggle [(checked)]="slot.allowNoAddedWeight"></cs-toggle>
        </div>
        <div class="exercise-list">
          @for (exerciseEntry of slot.testExercises; track exerciseEntry) {
            <div class="exercise-row">
              <!-- [ariaLabel] names the picker: the remove button shares this row, so there is
                   no row text the select can take its name from -->
              <cs-select class="exercise-select" [ariaLabel]="'Exercise' | untranslated"
                [placeholder]="'Select exercise...' | untranslated" [(value)]="exerciseEntry.exerciseId"
                [searchable]="true">
                @for (e of globalTestExercises; track e) {
                  <cs-select-option [value]="e._id" [label]="e.name | untranslated"></cs-select-option>
                }
              </cs-select>
              <cs-icon-button icon="close" (click)="removeTestExercise(exerciseEntry)"></cs-icon-button>
            </div>
          }
        </div>
        <cs-button tertiary icon="add" (click)="addTestExercise()">Add Test Exercise</cs-button>
      </div>
    </div>
  }
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="handleCancel($event)">
  <cs-button primary medium [label]="'Save' | untranslated" (click)="handleSaveAndExit($event)"></cs-button>
</cs-page-action-buttons>